import { toNumber } from 'lodash-es';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { org, updateOgInfo } from 'services/api/admin';
import { errorToasterWithServerMsg } from 'utils/errorToaster';
import { on } from 'services/nim/eventBus';

export type OrgValue = Oversea.Org & { orgId?: number; expiredInDays?: number };

function mergeOrgInfo(info: Oversea.Org): OrgValue {
  return {
    ...info,
    orgId: toNumber(info.id),
    expiredInDays: info.activeExpireDay,
  };
}

export const orgState = atom<OrgValue | undefined>();
orgState.onMount = (setAtom) => {
  let active = true;
  let refreshTimer: ReturnType<typeof setTimeout> | undefined;
  const refresh = () => {
    org()
      .then(mergeOrgInfo)
      .then((value) => {
        if (active) setAtom(value);
      })
      .catch((e) => {
        if (active) errorToasterWithServerMsg(e, '获取org信息失败，请稍后再试');
      });
  };

  // 套餐状态属于全局 org，不应依赖支付弹窗仍打开或订单号仍匹配。
  const off = on('sys:message:pay', ({ content: { result } }) => {
    if (result !== 'success') return;
    clearTimeout(refreshTimer);
    // 与支付页面保持相同延迟，等待服务端套餐信息更新。
    refreshTimer = setTimeout(refresh, 1000);
  });
  refresh();

  return () => {
    active = false;
    off();
    clearTimeout(refreshTimer);
  };
};

export const useOrgValue = () => useAtomValue(orgState);
export const useSetOrgValue = () => useSetAtom(orgState);

export const useOrgInfoRrefesher = () => {
  const setOrg = useSetOrgValue();
  return () => {
    org().then((org) => setOrg(mergeOrgInfo(org)));
  };
};

export const useOrgNameUpdater = () => {
  const refresher = useOrgInfoRrefesher();
  return async (name: string) => {
    await updateOgInfo({ name });
    refresher();
  };
};
